import React from 'react'
import {Flex, FlexItem, Cells, Cell, CellBody, CellFooter, Mask
} from 'react-weui'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import axios from 'axios'
import leftPad from 'left-pad'
import { browserHistory } from 'react-router'
import { storage, renderMoney } from '../../utils'
import handImg from '../../images/account/hand.png'
import { Page } from '../../components'
import { WKVisible, WKTag, WKBottomNav } from '../../components/wk'
import * as liveroomAction from '../../actions/liveroom'

import vipImg from '../../images/account/cj_vip.png'
import noVipImg from '../../images/account/cj_vip_g.png'
import '../../css/page/AccountPage.css'
import FloatCoupon from '../../components/activity/FloatCouponSpecial/FloatCoupon'
import {setEvent} from "../../services";
import { prodConfig } from '../../config'

class AccountPage extends React.Component {
    constructor (props) {
        super(props)
        // 新功能弹窗
        this.featureAlertStorageField = 'wk-feature-180322'
        this.is_promote_flag = browserHistory.getCurrentLocation().query.is_promote_flag ? true : false // 如果有这个参数隐藏一些icon
        this.state = {
            account: {},
            btns: [],
            myLiveroom: {},
            stats: {},
            manageLiverooms: [],
            activityDialogShow: false
        }
        this.isShowPunchAnimation = false
    }
    //新版优惠券弹窗-2017.11.06-zxp
    handleCloseActivityDialog() {
        this.setState({activityDialogShow: false});
    }
    componentDidMount () {
        document.title = '个人中心'
        this.ShowPunchAnimation() // 特例
        const accountPageData = storage.getItem('account_page_data')
        if (accountPageData) {
            this.setState({...accountPageData, activityDialogShow: false}, () => {
                //新版优惠券弹窗-2017.11.06-zxp
                if (!localStorage.getItem(this.featureAlertStorageField)) {
                    localStorage.setItem(this.featureAlertStorageField, true);
                    this.setState({activityDialogShow: true});
                }
            })
        }
        this.fetchData()

        // this.isMember()

        this.props.dispatch({ type: 'MTA_CLICK', payload: 'show_shuangqian_account' })
    }
    fetchData () {
        axios.get('/api/account/center?version=2')
            .then(res => {

                // 新增加的联系客服接口
                const btn = {
                    icon: "https://static-1253442168.file.myqcloud.com/xupload/20180201_help@3x.png",
                    name: "联系客服",
                    page: "customer-service",
                    url: `${prodConfig.MAIN_URL}/activity/servicepage/`
                }
                res.data.data.btns[1].push(btn)
                
                this.setState({
                    account: res.data.data.account,
                    btns: res.data.data.btns,
                    myLiveroom: res.data.data.my_liveroom,
                    stats: res.data.data.stats,
                    manageLiverooms: res.data.data.manage_liverooms || [],
                }, () => {
                    storage.setItem('account_page_data', {...this.state, activityDialogShow: false});
                    //新版优惠券弹窗-2017.11.06-zxp
                    if (!localStorage.getItem(this.featureAlertStorageField)) {
                        localStorage.setItem(this.featureAlertStorageField, true);
                        this.setState({activityDialogShow: true});
                    }
                })
            })
    }
    toEditAccount () {
        location.assign('/account/edit')
    }

    renderBalance() {
        if(!this.state.stats.balance)
            return null
        return <span className="balance">
            余额 {renderMoney(this.state.stats.balance)} 元
        </span>
    }

    renderResell() {
        return <span className="balance resell-cell">0成本赚钱！点我</span>
    }

    renderBtnItem (item) {
        let assignFn = e => location.assign(item.url)
        let isShowBadge = false
        if (item.target === '_blank') {
            assignFn = e => window.open(item.url)
        } else {
            switch (item.page) {
                case 'bought':
                case 'setting':
                    assignFn = e => location.assign(`/account/${item.page}`)
                    break
                case 'wallet':
                    assignFn = e => {
                        location.assign('/wallet')
                    }
                    break
                case 'help':
                    assignFn = e => location.assign(`/question`)
                    break
                case 'schedule':
                    assignFn = e => {
                        storage.setItem('click_schedule_time', Date.now())
                        location.assign(`/schedule/my`)
                    }
                    break
                case 'resell':
                    assignFn = e => {
                        location.assign('/resell/account')
                    }
                    break
            }
        }
        //接入APP下载埋点
        if (item.page === 'app'){
            assignFn = () => {
                this.props.dispatch({
                    type: 'MTA_CLICK',
                    payload: 'account_page_app'
                });
                location.assign(item.url);
            }
        }
        return (
            <Cell 
                href="javascript:;" 
                access 
                key={item.url}
                onClick={assignFn}
                data-growing-title={item.name}
            >
                <CellBody>
                    {item.name}
                    {/* {isShowBadge && <Badge dot preset="body" />} */}
                </CellBody>
                <CellFooter>
                    {item.page === 'wallet' && this.renderBalance()}
                    {(item.page === 'pgy' && !this.is_promote_flag) && this.renderResell()}
                    {item.page === 'schedule' && this.renderScheduleBadge()}
                    {isShowBadge && this.renderNewBadge()}
                </CellFooter>
            </Cell>
        )
    }
    // new badge
    renderNewBadge () {
        return null
        return <div className="count-badge is-many">new</div>
    }

    // 打卡的badge
    renderScheduleBadge () {
        const currentDateIst = new Date()
        const year = currentDateIst.getFullYear()
        const month = leftPad(currentDateIst.getMonth() + 1, 2, '0')
        const date = leftPad(currentDateIst.getDate(), 2, '0')
        const todayZeroTime = Date.parse(`${year}-${month}-${date}T00:00:00`)
        const clickTime = storage.getItem('click_schedule_time')
        if (clickTime >= todayZeroTime) {
            return null
        }
        const count = this.state.stats.unsignin_schedule_count
        if (count > 0 && count < 10) {
            return (
                <div className="count-badge">{count}</div>
            )
        }
        if (count >= 10 && count < 100) {
            return (
                <div className="count-badge is-many">{count}</div>
            )
        }
        if (count >= 100) {
            return (
                <div className="count-badge is-many">99+</div>
            )
        }
    }
    renderLiveroomVerifyTypeIcon(liveroom) {
        if(liveroom.verify_type === 1){
            return <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv"></i>
        }else if(liveroom.verify_type === 2){
            return <i className="iconfont verify-type-icon icon-yfv"></i>
        }
        return null
    }
    isShowCouponBadge (num) {
        if (num <= 0) {
            return false
        } else {
            const now = Date.now()
            const time = +storage.getItem('wk-account-click-coupon-time')
            if (time + 86400 * 1000 < now) {
                return true
            } else {
                return false
            }
        }
    }

    ShowPunchAnimation() {
        // 特例 打卡入口的动画算是
        const getNowDayNow = new Date().toLocaleDateString()
        if (storage.getItem('WKIndex/Punch/entries')) {
            const getUserPunchEntriesDay = storage.getItem('WKIndex/Punch/entries')
            if (getNowDayNow != getUserPunchEntriesDay) {
                storage.setItem('WKIndex/Punch/entries', getNowDayNow)
                this.isShowPunchAnimation = true
            }
        } else {
            this.isShowPunchAnimation = true
            storage.setItem('WKIndex/Punch/entries', getNowDayNow)
        }
    }

    onClickMyCoupon () {
        storage.setItem('wk-account-click-coupon-time', Date.now())
        location.assign('/account/coupons')
    }
    render() {
        const { myLiveroom, manageLiverooms, stats ,account} = this.state
        return (
            <Page>
                {!this.is_promote_flag &&
                <FloatCoupon/>
                }

                <div className="account-page wk-inner-page">
                    <div className="account-top">
                        <div className={account.is_lecturer?'profile profile-is-lecturer':'profile'} onClick={e => location.assign('/account/edit')}>
                            <div className="avatar-url">
                                <img src={this.state.account.avatar_url} className="avatar"/>
                            </div>
                            <div className="avatar-box">
                                <div className="name">
                                    <label>{this.state.account.nickname}</label>
                                </div>
                                <div className="desc">{this.state.account.introduction || '这个人有点懒～什么都还没有留下'}</div>
                            </div>
                        </div>
                        {/*签到入口，开放*/}
                            <div style={{position: 'absolute', right: 0}}>
                                <a href="/homepage/punch?entries=account">
                                    <div className="account-page-specials-punch">
                                        <p className={`${this.isShowPunchAnimation? 'punchAnimation' : ''}`}>签到中心 <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_28f71cd21165081a56c4ed1a5edcfeda.jpg" alt=""/></p>
                                    </div>
                                </a>
                            </div>
                    </div>
                    <div className="dashboard wk-border-line-after wk-position-rlt">
                        <Flex>
                            <FlexItem onClick={e => location.assign('/account/favourites')}>
                                <div className='title'>收藏</div>
                                <div className="count">{this.state.stats.favourite_lecture_count || 0}</div>
                            </FlexItem>
                            <FlexItem onClick={e => location.assign('/account/follows')}>
                                <div className='title'>关注</div>
                                <div className="count">{this.state.stats.follow_liveroom_count || 0}</div>
                            </FlexItem>
                            <FlexItem onClick={e => location.assign('/message/my')}>
                                <div className='title msg'>
                                    消息
                                    <WKVisible create={this.state.stats.unread_message_count > 0}>
                                        <div className="badge"></div>
                                    </WKVisible>
                                </div>
                                <div className="count">{this.state.stats.unread_message_count || 0}</div>
                            </FlexItem>
                            <FlexItem onClick={e => this.onClickMyCoupon()}>
                                <div className='title'>
                                    优惠券
                                    <WKVisible create={this.isShowCouponBadge(stats.coupon_number)}>
                                        <div className="badge" style={{right: '22%'}}></div>
                                    </WKVisible>
                                </div>
                                <div className="count">{this.state.stats.coupon_number || 0}</div>
                            </FlexItem>
                        </Flex>
                    </div>
                    {/* 没有创建直播间 */}
                    <WKVisible create={this.state.myLiveroom == null}>
                        <div className="join-liveroom wk-position-rlt wk-border-line-after">
                            <button className='wk-pointer-hand' onClick={e => location.assign('/liveroom/create/guide')}>
                                <img src={handImg} alt='' /> 我要开课
                            </button>
                        </div>
                    </WKVisible>
                    {/* 没有直播间但是有管理 */}
                    {
                        (manageLiverooms.length > 0 && myLiveroom == null) && (
                            <div className="margin-top multiple-liveroom">
                                <Cells>
                                    <Cell>
                                        <CellBody>
                                            直播间
                                        </CellBody>
                                    </Cell>
                                    {
                                        manageLiverooms.map(item => (
                                            <Cell
                                                href="javascript:;" 
                                                access 
                                                onClick={e => location.assign(`/liveroom/${item.id}`)}
                                                key={item.id}
                                                data-growing-title={item.name}
                                            >
                                                <CellBody>
                                                    <div className="avatar">
                                                        <img src={item.small_avatar_url} />
                                                        {this.renderLiveroomVerifyTypeIcon(item)}
                                                    </div>
                                                    {item.name} 
                                                    <WKTag text={'管理'} bgColor={'#FF9C00'} fontColor={'#fff'}/>
                                                </CellBody>
                                                <CellFooter/>
                                            </Cell>
                                        ))
                                    }
                                </Cells>
                            </div>
                        )
                    }
                    {/* 又有直播间又有管理 */}
                    {
                        (manageLiverooms.length > 0 && myLiveroom) && (
                            <div className="margin-top multiple-liveroom">
                                <Cells>
                                    <Cell>
                                        <CellBody>
                                            直播间
                                        </CellBody>
                                    </Cell>
                                    <Cell 
                                        href="javascript:;" 
                                        access 
                                        onClick={e => location.assign(`/liveroom/${myLiveroom.id}`)}
                                        data-growing-title={myLiveroom.name}
                                    >
                                        <CellBody>
                                            <div className="avatar">
                                                <img src={myLiveroom.small_avatar_url} />
                                                {this.renderLiveroomVerifyTypeIcon(myLiveroom)}
                                            </div>
                                            {myLiveroom.name} 
                                        </CellBody>
                                        <CellFooter/>
                                    </Cell>
                                    {
                                        manageLiverooms.map(item => (
                                            <Cell
                                                href="javascript:;" 
                                                access 
                                                onClick={e => location.assign(`/liveroom/${item.id}`)}
                                                key={item.id}
                                                data-growing-title={item.name}
                                            >
                                                <CellBody>
                                                    <div className="avatar">
                                                        <img src={item.small_avatar_url} />
                                                        {this.renderLiveroomVerifyTypeIcon(item)}
                                                    </div>
                                                    {item.name} 
                                                    <WKTag text={'管理'} bgColor={'#FF9C00'} fontColor={'#fff'}/>
                                                </CellBody>
                                                <CellFooter/>
                                            </Cell>
                                        ))
                                    }
                                </Cells>
                            </div>
                        )
                    }
                    {/* 只有直播间 */}
                    {
                        (this.state.manageLiverooms.length === 0 && this.state.myLiveroom) && (
                            <div className="margin-top multiple-liveroom">
                                <Cells>
                                    <Cell>
                                        <CellBody>
                                            直播间
                                        </CellBody>
                                    </Cell>
                                    <Cell 
                                        href="javascript:;" access 
                                        onClick={e => location.assign(`/liveroom/${this.state.myLiveroom.id}`)}
                                        data-growing-title={myLiveroom.name}
                                    >
                                        <CellBody>
                                            <div className="avatar">
                                                <img src={myLiveroom.small_avatar_url} />
                                                {this.renderLiveroomVerifyTypeIcon(myLiveroom)}
                                            </div>
                                            {myLiveroom.name} 
                                        </CellBody>
                                        <CellFooter/>
                                    </Cell>
                                </Cells>
                            </div>
                        )
                    }
                    {/* 后端控制的按钮组 */}
                    {
                        this.state.btns.map((item, i) => (
                            <Cells key={i}>
                                {
                                    item.map((_item) => (
                                        _item.page === 'pgy' && this.is_promote_flag ? '' : this.renderBtnItem(_item)
                                    ))
                                }
                            </Cells>
                        ))
                    }
                    <WKBottomNav/>
                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    account: state.account
}), dispatch => bindActionCreators({...liveroomAction, dispatch}, dispatch))(AccountPage)


// WEBPACK FOOTER //
// ./src/pages/AccountPage/AccountPage.js